<template>
<div class="textile-color-picker">
  <p class="wph-mb-4">Цвет {{ isBag ? 'пакета' : 'текстиля' }}: <span class="wph-text-accent-dark wph-font-bold">{{ cartItem.color.label }}</span></p>
  <div class="textile-color-picker__color-swatches">
    <div v-for="(color, index) in cartItem.model.colors" :key="index"
      @click="pickColor(color)"
      class="textile-color-picker__color-swatch"
      :class="{ 'textile-color-picker__color-swatch--active': cartItem.color.id === color }"
      :style="{
        backgroundColor: colors[color].hex
      }"
      :title="colors[color].label"
    ></div>
  </div>
</div>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    cartItem: { type: Object, required: true },
    updateItemColor: { type: Function, required: true },
  },
  computed: {
    isBag() {
      return this.cartItem.type.id === 'bags'
    },
    colors() {
      return !this.isBag ? this.$store.state.textileColors : this.$store.state.bagColors
    },
    // индексы слайдов, привязанных к цвету
    // return { 'color-name': Number index, ... }
    coloredSlideIndexes() {
      let indexes = {}
      this.cartItem.model.slides.forEach((slide, index) => {
        if (!slide.color) {
          return
        }
        if (!indexes[slide.color]) {
          indexes[slide.color] = index
        }
      })
      return indexes
    },
  },
  methods: {
    pickColor(color) {
      this.updateItemColor({ color: this.colors[color] })
    },
  },
}
</script>